import { Link } from 'react-router-dom'

const navLinks = [
  { label: 'Inicio', href: '/' },
  { label: 'Quienes Somos', href: '/quienes-somos' },
  { label: 'Consultas', href: '/consultas' },
  { label: 'Medicina Preventiva', href: '/medicina-preventiva' },
  { label: 'Atención por Especie', href: '/atencion-por-especie' },
  { label: 'Cirugía', href: '/cirugia' },
  { label: 'Internación y Cuidados', href: '/internacion-y-cuidados' },
  { label: 'Enfermería', href: '/enfermeria' },
  { label: 'Laboratorio', href: '/laboratorio-basico' },
  { label: 'Dermatología', href: '/dermatologia' },
  { label: 'Odontología', href: '/odontologia' },
  { label: 'Producción Animal', href: '/produccion-animal' },
  { label: 'Bromatología', href: '/bromatologia' },
  { label: 'Bienestar y Asesoramiento', href: '/bienestar-y-asesoramiento' },
  { label: 'Cursos', href: '/cursos' },
  { label: 'Contacto', href: '/contacto' },
]

const contactInfo = {
  phone: '+54 299 672-7809',
  email: 'elhorconcriollo@gmail.com',
  instagram: '@Elhorconcriollo',
}

function Footer() {
  return (
    <footer className="bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Enlaces Rápidos</h3>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm hover:text-accent transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contacto</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="ph ph-phone text-xl"></i>
                <span className="text-sm">{contactInfo.phone}</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ph ph-envelope text-xl"></i>
                <span className="text-sm">{contactInfo.email}</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ph ph-instagram-logo text-xl"></i>
                <span className="text-sm">{contactInfo.instagram}</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Acerca de</h3>
            <p className="text-sm text-gray-200 mb-4">
              El Horcon Criollo es una veterinaria profesional dedicada a la atención integral de animales de compañía y de producción.
            </p>
            <p className="text-xs text-gray-300">
              © {new Date().getFullYear()} El Horcon Criollo. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer